// The top-down editor drawing (spec D9): an SVG string in tray millimetres. Front = bottom edge:
// SVG y grows downward, tray y grows backward, so every cell is drawn at y = d − c.y − c.d.
import { fmt } from './doc.js';
export const labelFor = (c) => `${fmt(c.w)} × ${fmt(c.d)}`;
const n = (v) => String(Math.round(v * 1000) / 1000);
export function renderSvg(doc, lay, { sel = null, bad = [] } = {}) {
  const { w, d } = doc.size, fs = Math.min(9, Math.max(3, Math.min(w, d) / 28));
  const out = [`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${n(w)} ${n(d)}" preserveAspectRatio="xMidYMid meet" role="img">`,
    `<rect class="outline" x="0" y="0" width="${n(w)}" height="${n(d)}" rx="${n(doc.params.fillet)}"/>`];
  for (const c of lay.cells) {
    const cls = ['cell', c.id === sel ? 'sel' : '', bad.includes(c.id) ? 'bad' : ''].filter(Boolean).join(' ');
    const y = d - c.y - c.d, label = labelFor(c);
    const fits = label.length * 0.55 * fs <= c.w - 1 && fs * 1.3 <= c.d - 1;
    out.push(`<g class="${cls}" data-id="${c.id}"><rect x="${n(c.x)}" y="${n(y)}" width="${n(Math.max(0, c.w))}" height="${n(Math.max(0, c.d))}"/>` +
      (fits ? `<text x="${n(c.x + c.w / 2)}" y="${n(y + c.d / 2)}" font-size="${n(fs)}" text-anchor="middle" dominant-baseline="central">${label}</text>` : '') + '</g>');
  }
  out.push('</svg>');
  return out.join('');
}
